module.exports = __webpack_public_path__ + "static/img/04_pro.ec4d5b2.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/rz/04_pro.jpg
// module id = delN
// module chunks = 0